/* gd-faq.js — a pesquisa da FAQ (Task 12, 12-09-2026). Filtra o que já está na página: nenhum pedido,
   nenhuma biblioteca. Sem acentos nem maiúsculas («echange» encontra «échange»). Um grupo inteiro — e a sua
   ficha na navegação — esconde-se quando nenhuma das suas perguntas passa, senão ficavam títulos a apontar
   para o vazio. Com 3 letras ou mais a resposta abre-se (quem procura quer ler); limpar fecha tudo.
   Escape limpa o campo, como em qualquer pesquisa. */
(() => {
  const norm = (s) => (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/\s+/g, ' ').trim();

  class GdFaq extends HTMLElement {
    connectedCallback() {
      this.caixa = this.querySelector('[data-gd-faq-q]');
      this.vazio = this.querySelector('[data-gd-vazio]');
      this.itens = [...this.querySelectorAll('[data-gd-item]')].map((el) => ({ el, txt: norm(el.textContent) }));
      this.grupos = [...this.querySelectorAll('[data-gd-grupo]')];
      if (!this.caixa || !this.itens.length) return;
      this.caixa.addEventListener('input', () => this.filtrar());
      this.caixa.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.caixa.value) { e.preventDefault(); this.caixa.value = ''; this.filtrar(); }
      });
      if (this.caixa.value) this.filtrar(); // o browser pode repor o texto ao voltar atrás
    }

    filtrar() {
      const t = norm(this.caixa.value);
      let achou = 0;
      for (const { el, txt } of this.itens) {
        const passa = !t || txt.includes(t);
        el.hidden = !passa;
        if (!t) el.open = false;
        else if (passa && t.length > 2) el.open = true;
        if (passa) achou++;
      }
      for (const g of this.grupos) {
        const vazio = !g.querySelector('[data-gd-item]:not([hidden])');
        g.hidden = vazio;
        const ficha = this.querySelector(`[data-gd-ficha="${g.id}"]`);
        if (ficha) ficha.hidden = vazio;
      }
      if (this.vazio) this.vazio.hidden = achou > 0;
    }
  }

  if (!customElements.get('gd-faq')) customElements.define('gd-faq', GdFaq);
})();
